import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  CASSubtype,
  useSubtypesTableContext,
} from '../../../../SubtypesTableContext'
import { CreateEditFormItems } from '../../components/CreateEditFormItems'
import { useCreateCasSubtypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useProjectContext } from 'context/ProjectContext'

export function useCreateOptions(): CreateHeaderActionOptions<CASSubtype> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useSubtypesTableContext()
  const [create] = useCreateCasSubtypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createCASSubtype: {
        subtype: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Subtype',
    permission: Permission.CreateCASSubtype,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({ name, description }: CreateEditFormItemsValues) => {
        await create({
          variables: {
            createCASSubtypeInput: { projectId, name, description },
          },
        })
        refetch()
      },
    },
  }
}
